import React from 'react'

export const MessageHoverIcon = () => {
  return (
    <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.589844" width="48" height="48" rx="24" fill="url(#paint0_linear_6899_29596)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3867 31.3796C15.3157 31.3796 13.6367 29.7006 13.6367 27.6296V18.6438C13.6367 16.5728 15.3157 14.8938 17.3867 14.8938H31.7927C33.8638 14.8938 35.5427 16.5728 35.5427 18.6438V27.6296C35.5427 29.7006 33.8638 31.3796 31.7927 31.3796H27.2289L21.3632 36.1062V33.3679V32.3191V31.3796H17.3867ZM19.5562 21.9756C18.7875 21.9756 18.1643 22.5988 18.1643 23.3675C18.1643 24.1362 18.7875 24.7593 19.5562 24.7593C20.3249 24.7593 20.948 24.1362 20.948 23.3675C20.948 22.5988 20.3249 21.9756 19.5562 21.9756ZM28.2318 23.3675C28.2318 22.5988 28.855 21.9756 29.6237 21.9756C30.3924 21.9756 31.0155 22.5988 31.0155 23.3675C31.0155 24.1362 30.3924 24.7593 29.6237 24.7593C28.855 24.7593 28.2318 24.1362 28.2318 23.3675ZM24.5897 21.9756C23.821 21.9756 23.1979 22.5988 23.1979 23.3675C23.1979 24.1362 23.821 24.7593 24.5897 24.7593C25.3584 24.7593 25.9816 24.1362 25.9816 23.3675C25.9816 22.5988 25.3584 21.9756 24.5897 21.9756Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6899_29596"
          x1="0.589844"
          y1="0"
          x2="55.2324"
          y2="57.2964"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E691" />
          <stop offset="1" stopColor="#0145FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
